import { Outlet, useLocation } from "react-router";
import { mandatorsConfig, useMandatorContext } from "@rentablo/theming";
import { useFeatureFlag } from "@hooks/useFeatureFlag";
import { matchWebFormEntry } from "./webFormEntries";
import { TppWebFormLauncher } from "./TppWebFormLauncher";

/**
 * Sits in front of the in-app import routes. For a web-form-only mandator the
 * routes that start a flow create the web form here; the rest, the bank's
 * returns to flows already under way included, still reach the in-app flow.
 */
export const WebFormEntryGate = () => {
  const isWebFormOnly = useFeatureFlag("TPP_WEB_FORM_ONLY");
  const { mandatorSlug } = useMandatorContext();
  // Not useFeatureFlag: that falls back to rentablo's flags, and the form reads
  // the mandator's own. Where the mandator sets none the form shows no note, so
  // the app has to.
  const isLegalNoteInFlow =
    mandatorsConfig[mandatorSlug]?.featureFlags?.LEGAL_NOTE_IN_FLOW ?? false;
  const { pathname, search } = useLocation();
  const entry = isWebFormOnly
    ? matchWebFormEntry(pathname, new URLSearchParams(search), {
        isLegalNoteInFlow,
      })
    : null;

  if (!entry) return <Outlet />;

  return <TppWebFormLauncher key={pathname + search} entry={entry} />;
};
